import './style.scss'

import React, { Component } from 'react'

import Button from 'components/UI/Button'
import PropTypes from 'prop-types'
import Icon from 'components/UI/Icon'
import plus from 'img/plus.svg'
import minus from 'img/minus.svg'

export default class CartCounterMobile extends Component {
    render() {
        const { value, onIncrease, onDecrease } = this.props
        return (
            <div className="cart-counter-mobile">
                <Button
                    variant="secondary"
                    shape="circle"
                    className="cart-counter-mobile__button"
                    onClick={onDecrease}
                >
                    <Icon svg={minus} />
                </Button>
                <span className="cart-counter-mobile__value">{value}</span>
                <Button
                    variant="primary"
                    shape="circle"
                    className="cart-counter-mobile__button"
                    onClick={onIncrease}
                >
                    <Icon svg={plus} />
                </Button>
            </div>
        )
    }
}

CartCounterMobile.propTypes = {
    view: PropTypes.string,
    value: PropTypes.number.isRequired,
    onIncrease: PropTypes.func.isRequired,
    onDecrease: PropTypes.func.isRequired,
}
